import React from "react";
import { Link } from "react-router-dom";
import logoBig from '../../assets/img/logoBig.png';
import {FooterWrapper} from "./Footer.styles";



const Footer = () => {

    return(
        <FooterWrapper>
            <div className={"footerInside"}>
                <Link to="/">
                    <img src={logoBig} alt="logo" />
                </Link>
                <div className={"linksDiv"}>
                   <Link to="/select-draft" className="footer-link">Mock Draft Simulator</Link>
                    <Link to="/draft-value-chart" className="footer-link">Draft Value Chart</Link>
                    <Link to="/players" className="footer-link">Players</Link>
                    <Link to="/team-needs" className="footer-link">Team Needs</Link>
                </div>
                <div className={"inputDiv"}>
                    <input type={"email"} placeholder={"Email address"} />
                    <div className={"inputDescription"}>Lorem ipsum dolor sit amet consectetur. Habitant mi urna vel
                         integer. Eget sed id massa sed. Cursus enim sit eget eget. Ac non laoreet in in magna platea
                         risus neque blandit.</div>
                    <button>Subscribe</button>
                </div>
            </div>
        </FooterWrapper>
    )
}

export default Footer;